import {HttpErrorResponse} from '@angular/common/http';
import {Action} from '@ngrx/store';
import {Sked, SkedContext} from 'src/app/current-sked/shared/model/sked';
import {TaskStatusActions} from 'src/app/current-sked/shared/task-status-actions';
import {UpdateSubtaskMetric} from 'src/app/current-sked/task-detail/current-sked-task-detail.component';
import {Alert} from '../../model/alert';
import {CurrentSkedTask, SubtaskNote} from '../../model/task';
import {SubtaskFormState} from './current-sked.state';
import {
  CSChallengeData,
  CSChallengeCycle,
  CSChartDetail,
  CurrentSkedChallenge,
  MetricUpdate,
} from '../../model/project';

export enum CurrentSkedActionType {
  GET = '[Current Sked] Get',
  GET_SUCCESS = '[Current Sked] Get :: Success',

  GET_TASK = '[Current Sked] Get Task',
  GET_TASK_SUCCESS = '[Current Sked] Get Task :: Success',

  GET_PROJECT = '[Current Sked] Get Project',
  GET_PROJECT_SUCCESS = '[Current Sked] Get Project :: Success',
  GET_CHALLENGE = '[Current Sked] Get Challenge',
  GET_CHALLENGE_SUCCESS = '[Current Sked] Get Challenge :: Success',
  GET_CYCLE_DAY = '[Current Sked] Get Cycle Day',
  GET_CYCLE_DAY_SUCCESS = '[Current Sked] Get Cycle Day :: Success',
  GET_CHALLENGE_CYCLE = '[Current Sked] Get Challenge Cycle',
  GET_CHALLENGE_CYCLE_SUCCESS = '[Current Sked] Get Challenge Cycle :: Success',

  GET_CS_CHALLENGE_DAY_DETAIL = '[Current Sked] Get CS Challenge Day Detail',
  GET_CS_CHALLENGE_DAY_DETAIL_SUCCESS = '[Current Sked] Get CS Challenge Day Detail :: Success',
  GET_CS_CHALLENGE_DAY_DETAIL_FAILURE = '[Current Sked] Get CS Challenge Day Detail :: Failure',

  SAVE_CHALLENGE_METRIC_VALUES = '[Current Sked] Save Challenge Metric Values',
  SAVE_CHALLENGE_METRIC_VALUES_SUCCESS = '[Current Sked] Save Challenge Metric Values :: Success',

  CHANGE_TASK_STATUS = '[Current Sked] Change Task Status',
  CHANGE_TASK_STATUS_SUCCESS = '[Current Sked] Change Task Status :: Success',

  COMPLETE_TASK = '[Current Sked] Complete Task',
  COMPLETE_TASK_SUCCESS = '[Current Sked] Complete Task :: Success',

  CHANGE_SUBTASK_STATUS = '[Current Sked] Change Subtask Status',
  CHANGE_SUBTASK_STATUS_SUCCESS = '[Current Sked] Change Subtask Status :: Success',

  UPDATE_SUBTASK_METRICS = '[Current Sked] Update Subtask Metrics',
  UPDATE_SUBTASK_METRICS_SUCCESS = '[Current Sked] Update Subtask Metrics :: Success',

  CHANGE_THEME = '[Current Sked] Change Theme',

  UPDATE_CURRENT_SKED = '[Current Sked] Update Current Sked',
  UPDATE_CURRENT_SKED_SUCCESS = '[Current Sked] Update Current Sked :: Success',

  UPDATE_VALUE_CHOSEN = '[Current Sked] Update Current Sked Value Chosen',
  CLEAR_VALUE_CHOSEN = '[Current Sked] Clear Current Sked Value Chosen',

  ADD_SUBTASK_NOTE = '[Current Sked] Add Subtask Note',
  ADD_SUBTASK_NOTE_SUCCESS = '[Current Sked] Add Subtask Note :: Success',

  CLEAR_TASK = '[Current Sked] Clear Task',

  UPDATE_SKED_CONTEXT = '[Current Sked] Update Sked Context',
  UPDATE_SKED_CONTEXT_SUCCESS = '[Current Sked] Update Sked Context :: Success',

  UPDATE_METRIC_FORM_STATE = '[Current Sked] Update Metric Form State',
  CLEAR_METRIC_FORM_STATE = '[Current Sked] Clear Metric Form State',

  CLEAR = '[Current Sked] Clear',
}

export class GetCurrentSkedAction implements Action {
  public readonly type = CurrentSkedActionType.GET;

  public constructor(
    public payload: {
      expired: boolean;
      onSuccess?: (currentSked: Sked) => void;
      onFailure?: (error: HttpErrorResponse) => void;
    }
  ) {}
}

export class GetCurrentSkedSuccessAction implements Action {
  public readonly type = CurrentSkedActionType.GET_SUCCESS;

  public constructor(public payload: {sked: Sked; teamSked: Sked; expired: boolean}) {}
}

//------------------------------------------------------------

export class GetCurrentSkedTaskAction implements Action {
  public readonly type = CurrentSkedActionType.GET_TASK;

  public constructor(
    public payload: {
      taskId: string;
      onSuccess?: (task: CurrentSkedTask) => void;
      onFailure?: (error: Error) => void;
    }
  ) {}
}

export class GetCurrentSkedTaskSuccessAction implements Action {
  public readonly type = CurrentSkedActionType.GET_TASK_SUCCESS;

  public constructor(public payload: {task: CurrentSkedTask}) {}
}

//------------------------------------------------------------

export class GetCurrentSkedProjectAction implements Action {
  public readonly type = CurrentSkedActionType.GET_PROJECT;

  public constructor(
    public payload: {
      projectId: string;
      expired: boolean;
      onSuccess?: () => void;
      onFailure?: (error: HttpErrorResponse) => void;
    }
  ) {}
}

export class GetCurrentSkedProjectSuccessAction implements Action {
  public readonly type = CurrentSkedActionType.GET_PROJECT_SUCCESS;

  public constructor(public payload: {skedProject: Sked; expired: boolean}) {}
}

export class GetCurrentSkedChallengeAction implements Action {
  public readonly type = CurrentSkedActionType.GET_CHALLENGE;

  public constructor(
    public payload: {
      challengeId: string | undefined;
      onSuccess?: (currentSkedChallenge: CurrentSkedChallenge) => void;
      onFailure?: (error: Error) => void;
    }
  ) {}
}

export class GetCurrentSkedChallengeSuccessAction implements Action {
  public readonly type = CurrentSkedActionType.GET_CHALLENGE_SUCCESS;

  public constructor(public payload: {csChallengeData: CSChallengeData}) {}
}

export class GetChallengeCycleDayAction implements Action {
  public readonly type = CurrentSkedActionType.GET_CYCLE_DAY;

  public constructor(
    public payload: {
      challengeId: string;
      timestamp: string;
      onSuccess?: (data: CSChallengeData) => void;
      onFailure?: (error: Error) => void;
    }
  ) {}
}

export class GetChallengeCycleDaySuccessAction implements Action {
  public readonly type = CurrentSkedActionType.GET_CYCLE_DAY_SUCCESS;

  public constructor(public payload: {csChallengeData: CSChallengeData}) {}
}

export class GetCSChallengesCycleAction implements Action {
  public readonly type = CurrentSkedActionType.GET_CHALLENGE_CYCLE;

  public constructor(
    public payload: {
      projectId: string;
      date: string; // format: 2026-03-11
      onSuccess?: (cycle: CSChallengeCycle) => void;
      onFailure?: (error: Error) => void;
    }
  ) {}
}

export class GetCSChallengesCycleSuccessAction implements Action {
  public readonly type = CurrentSkedActionType.GET_CHALLENGE_CYCLE_SUCCESS;

  public constructor(public payload: {projectId: string; cycle: CSChallengeCycle}) {}
}

export class GetCSChallengeDayDetailAction implements Action {
  public readonly type = CurrentSkedActionType.GET_CS_CHALLENGE_DAY_DETAIL;

  public constructor(
    public payload: {
      projectId: string;
      dateKey: string;
      metricId: string;
      timestamp: string;
      onSuccess?: (detail: CSChartDetail) => void;
      onFailure?: (error: Error) => void;
    }
  ) {}
}

export class GetCSChallengeDayDetailSuccessAction implements Action {
  public readonly type = CurrentSkedActionType.GET_CS_CHALLENGE_DAY_DETAIL_SUCCESS;

  public constructor(public payload: {chartDetail: CSChartDetail}) {}
}

export class GetCSChallengeDayDetailFailureAction implements Action {
  public readonly type = CurrentSkedActionType.GET_CS_CHALLENGE_DAY_DETAIL_FAILURE;

  public constructor(public payload: {dateKey: string; metricId: string}) {}
}

export class SaveChallengeMetricValuesAction implements Action {
  public readonly type = CurrentSkedActionType.SAVE_CHALLENGE_METRIC_VALUES;

  public constructor(
    public payload: {
      projectId: string;
      updates: MetricUpdate[];
      onSuccess?: () => void;
      onFailure?: (error: Error) => void;
    }
  ) {}
}

export class SaveChallengeMetricValuesSuccessAction implements Action {
  public readonly type = CurrentSkedActionType.SAVE_CHALLENGE_METRIC_VALUES_SUCCESS;

  public constructor(public payload: {csChallengeData: CSChallengeData}) {}
}

//------------------------------------------------------------

export class CurrentSkedChangeTaskStatusAction implements Action {
  public readonly type = CurrentSkedActionType.CHANGE_TASK_STATUS;

  public constructor(
    public payload: {
      id: string;
      actionType: TaskStatusActions;
      onSuccess?: (task: CurrentSkedTask) => void;
      onFailure?: (error: Error) => void;
    }
  ) {}
}

export class CurrentSkedChangeTaskStatusSuccessAction implements Action {
  public readonly type = CurrentSkedActionType.CHANGE_TASK_STATUS_SUCCESS;

  public constructor(public payload: {task: CurrentSkedTask}) {}
}

export class CurrentSkedCompleteTaskAction implements Action {
  public readonly type = CurrentSkedActionType.COMPLETE_TASK;

  public constructor(
    public payload: {
      taskId: string;
      onSuccess?: (response: {task: CurrentSkedTask; activities: Alert[]}) => void;
      onFailure?: (error: Error) => void;
    }
  ) {}
}

export class CurrentSkedCompleteTaskSuccessAction implements Action {
  public readonly type = CurrentSkedActionType.COMPLETE_TASK_SUCCESS;

  public constructor(public payload: {task: CurrentSkedTask}) {}
}

//------------------------------------------------------------

export class CurrentSkedChangeSubtaskStatusAction implements Action {
  public readonly type = CurrentSkedActionType.CHANGE_SUBTASK_STATUS;

  public constructor(
    public payload: {
      taskId: string;
      subtaskId: string;
      complete: boolean;
      onSuccess?: (response: {task: CurrentSkedTask; activities: Alert[]}) => void;
      onFailure?: (error: Error) => void;
    }
  ) {}
}

export class CurrentSkedChangeSubtaskStatusSuccessAction implements Action {
  public readonly type = CurrentSkedActionType.CHANGE_SUBTASK_STATUS_SUCCESS;

  public constructor(public payload: {task: CurrentSkedTask}) {}
}

//------------------------------------------------------------
export class CurrentSkedUpdateSubtaskMetricsAction implements Action {
  public readonly type = CurrentSkedActionType.UPDATE_SUBTASK_METRICS;

  public constructor(
    public payload: {
      trackerId: string;
      taskId: string;
      metrics: UpdateSubtaskMetric[];
      subtaskId: string;
      timestamp?: string;
      taskExpired: boolean;
      onSuccess?: (response: {task: CurrentSkedTask; activities: Alert[]}) => void;
      onFailure?: (error: Error) => void;
    }
  ) {}
}

export class CurrentSkedUpdateSubtaskMetricsSuccessAction implements Action {
  public readonly type = CurrentSkedActionType.UPDATE_SUBTASK_METRICS_SUCCESS;

  public constructor(public payload: {task: CurrentSkedTask}) {}
}

//------------------------------------------------------------
export class UpdateCurrentSked implements Action {
  public readonly type = CurrentSkedActionType.UPDATE_CURRENT_SKED;

  public constructor(public payload: {sked: Sked; onSuccess?: (sked: Sked) => void}) {}
}

export class UpdateCurrentSkedSuccess implements Action {
  public readonly type = CurrentSkedActionType.UPDATE_CURRENT_SKED_SUCCESS;

  public constructor(public payload: {sked: Sked}) {}
}

export class UpdateCurrentSkedValueChosen implements Action {
  public readonly type = CurrentSkedActionType.UPDATE_VALUE_CHOSEN;

  public constructor(public payload: {id: string}) {} // the value will always be true, so only key is needed. key can be any id
}

export class ClearCurrentSkedValueChosen implements Action {
  public readonly type = CurrentSkedActionType.CLEAR_VALUE_CHOSEN;
}

export class AddSubtaskNoteAction implements Action {
  public readonly type = CurrentSkedActionType.ADD_SUBTASK_NOTE;

  public constructor(
    public payload: {
      subtaskNote: SubtaskNote;
      onSuccess?: (task: CurrentSkedTask) => void;
      onFailure?: (error: HttpErrorResponse) => void;
    }
  ) {}
}

export class AddSubtaskNoteSuccessAction implements Action {
  public readonly type = CurrentSkedActionType.ADD_SUBTASK_NOTE_SUCCESS;

  public constructor(public payload: {task: CurrentSkedTask}) {}
}

export class ClearCurrentSkedTaskAction implements Action {
  public readonly type = CurrentSkedActionType.CLEAR_TASK;
}

export class UpdateSkedContextAction implements Action {
  public readonly type = CurrentSkedActionType.UPDATE_SKED_CONTEXT;

  public constructor(
    public payload: {
      skedContext: SkedContext;
      onSuccess?: (skedContext: SkedContext) => void;
      onFailure?: (error: HttpErrorResponse) => void;
    }
  ) {}
}

export class UpdateMetricFormStateAction implements Action {
  public readonly type = CurrentSkedActionType.UPDATE_METRIC_FORM_STATE;

  public constructor(
    public payload: {
      taskId: string;
      subtaskId: string;
      formState: SubtaskFormState;
    }
  ) {}
}

export class ClearMetricFormStateAction implements Action {
  public readonly type = CurrentSkedActionType.CLEAR_METRIC_FORM_STATE;

  public constructor(
    public payload: {
      taskId: string;
      subtaskId: string;
    }
  ) {}
}

export class ClearCurrentSkedAction implements Action {
  public readonly type = CurrentSkedActionType.CLEAR;
}

export type CurrentSkedAction =
  | GetCurrentSkedAction
  | GetCurrentSkedSuccessAction
  | GetCurrentSkedTaskAction
  | GetCurrentSkedTaskSuccessAction
  | GetCurrentSkedProjectAction
  | GetCurrentSkedProjectSuccessAction
  | GetCurrentSkedChallengeAction
  | GetCurrentSkedChallengeSuccessAction
  | GetChallengeCycleDayAction
  | GetChallengeCycleDaySuccessAction
  | GetCSChallengesCycleAction
  | GetCSChallengesCycleSuccessAction
  | GetCSChallengeDayDetailAction
  | GetCSChallengeDayDetailSuccessAction
  | GetCSChallengeDayDetailFailureAction
  | SaveChallengeMetricValuesAction
  | SaveChallengeMetricValuesSuccessAction
  | CurrentSkedChangeTaskStatusAction
  | CurrentSkedChangeTaskStatusSuccessAction
  | CurrentSkedCompleteTaskAction
  | CurrentSkedCompleteTaskSuccessAction
  | CurrentSkedChangeSubtaskStatusAction
  | CurrentSkedChangeSubtaskStatusSuccessAction
  | CurrentSkedUpdateSubtaskMetricsAction
  | CurrentSkedUpdateSubtaskMetricsSuccessAction
  | UpdateCurrentSked
  | UpdateCurrentSkedValueChosen
  | AddSubtaskNoteAction
  | AddSubtaskNoteSuccessAction
  | ClearCurrentSkedValueChosen
  | ClearCurrentSkedTaskAction
  | UpdateSkedContextAction
  | UpdateMetricFormStateAction
  | ClearMetricFormStateAction
  | ClearCurrentSkedAction;
